import { render, staticRenderFns } from "./insCliente.html?vue&type=template&id=5061b795&"
import script from "./InsCliente.vue?vue&type=script&lang=js&"
export * from "./InsCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports